module.exports = __webpack_public_path__ + "img/atlas-2.a173a81a.png";